// extracted by mini-css-extract-plugin
export default {"container":"SupportingStatement_container__o++Ig","title":"SupportingStatement_title__CCDqa"};